import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapActions } from "vuex";
import { database as getDatabase } from "@/libs/util.db";
export default {
  data: function data() {
    return {
      loading: false,
      searchForm: {
        pn: 1,
        audit_status: 0,
        limit: 10,
        sort: '1'
      }
    };
  },
  created: function created() {
    this.getSearch();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["database", "get", "databasePage"])), {}, {
    getSearch: function getSearch() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, filterKeys;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getDatabase({
                path: '$page./community/audit',
                user: true,
                defaultValue: {}
              });
            case 1:
              _this.pageDB = _context.v;
              _context.n = 2;
              return _this.pageDB.value();
            case 2:
              data = _context.v;
              if (data.searchForm) {
                filterKeys = ["categories"];
                filterKeys.forEach(function (key) {
                  if (data.searchForm[key] !== undefined) {
                    _this.searchForm[key] = data.searchForm[key];
                  }
                });
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    next: function next() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, list;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _this2.searchForm.categories && (_this2.searchForm.categories = _this2.searchForm.categories.join(","));
              _context2.n = 1;
              return _this2.$api.getCommunityList(_this2.searchForm);
            case 1:
              res = _context2.v;
              list = res.data.list;
              if (list.length > 0) {
                if (list[0] && list[0].id) {
                  _this2.$router.push({
                    path: "/community/update",
                    query: {
                      id: list[0].id,
                      userId: list[0].user.id,
                      from: _this2.$route.query.from
                    }
                  });
                }
              } else {
                _this2.$message.success("已清空~");
              }
              _this2.loading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  })
};